import * as React from "react";

import "./HomePage2022.scss";
import classNames from "classnames";
import { Header } from "../../components/Header";
import { JoinUsPanel } from "./JoinUsPanel";
import { ProgramSchedule } from "./ProgramSchedule";
import { PanelCTA } from "./PanelCTA";
import Footer from "../../components/Footer";
import VideoPlaceholder from "./img/2022/homepage_videoplacheholder_@2x.jpg";
import VideoPlaceholderDark from "./img/2022/homepage_videoplacheholder_shaded_@2x.jpg";
import SeeItAgainBg from "./img/2022/homepage_TM_shaded_@2x.jpg";
import VrExperienceBg from "./img/2022/homepage_AR_block_@2x.jpg";
import {
  AnchorOutlineButton,
  OutlineButton,
} from "../../components/OutlineButton";
import { isMobile } from "react-device-detect";
import { Accolades } from "../media/Accolades";
import { VideoSectionTeaser } from "../../components/VideoSectionTeaser";
import QRCode from "./img/2022/homepage_FPO_QR_code_@2x.jpg"
import { ModalContext } from "../../components/modal/Modal";

interface IHomePageProps {}

export const HomePage2022: React.FunctionComponent<IHomePageProps> = (
  props
) => {
  const [showTeaser, setShowTeaser] = React.useState(true);

  function onTeaserLaunch() {
    setShowTeaser(false);
  }

  return (
    <div className={classNames("HomePage2022", { showTeaser })}>
      <Header />
      <VideoSectionTeaser
        video="https://jd-ces-2022.s3.amazonaws.com/media-resources/videos/05010_Experience_Farmer_3-Screen_v010.mp4"
        placeholder={showTeaser ? VideoPlaceholderDark : VideoPlaceholder}
        showPlayhead={false}
        onLaunch={() => onTeaserLaunch()}
        showTeaser={showTeaser}
      />
      <ProgramSchedule />
      <PanelCTA backgroundImage={SeeItAgainBg} className="SeeItAgain">
        <div>
          <h1>See it again</h1>
          <h3>
            Watch the CES<sup>®</sup> 2022 Press Conference
          </h3>
          <AnchorOutlineButton
            className="yellow"
            text="Watch Now"
            to="https://youtu.be/bZM_ZzxihTg"
          />
        </div>
      </PanelCTA>
      {/* <GamePanel /> */}
      <JoinUsPanel />

      <VRPanel />
      <Accolades title={"Early Accolades"} />
      <Footer />
    </div>
  );
};

export const VRPanel: React.FunctionComponent = (props) => {
  const { handleModal } = React.useContext(ModalContext);

  return (
    <PanelCTA backgroundImage={VrExperienceBg} className="VrExperience">
      <div>
        <h1>See Everything</h1>
        {isMobile && (
          <AnchorOutlineButton
            className="yellow"
            text="View AR Experience"
            to="https://jd-ces-2022.s3.amazonaws.com/AR/index.html"
          />
        )}
        {!isMobile && (
          <OutlineButton
            className="yellow"
            text="View AR Experience"
            onClick={() => handleModal({
              img: QRCode,
              suppressDownload: true,
              title: "Augmented Reality Experience",
              definition: <p className="qr-instructions">Scan the QR code with your mobile device to view the AR experience.</p>,
            })}
          />
        )}
      </div>
    </PanelCTA>
  );
};
